export default __webpack_public_path__ + "static/media/step2.20201bcf.webp";